export { default } from "./CalculateEmi.container";
